import { createEffect, sample } from 'effector';
import $$api from 'models/api';
import { $global } from 'models/store-global';

import AlertsService from 'services/AlertsService';

import { MyStore } from 'types/Store';

sample({
    clock: [
        $$api.misc.getPlansFx.failData,
        $$api.misc.getBillingAndPaymentsLinkFx.failData,
        $$api.misc.getRoleHTMLTemplateFx.failData,
    ],
    target: createEffect(AlertsService.handleError),
});

// Handle getPlans success
sample({
    source: $global,
    clock: $$api.misc.getPlansFx.doneData,
    fn: (store, data): MyStore => ({
        ...store,
        temp: {
            ...(store.temp || {}),
            plans: data,
        },
    }),
    target: $global,
});

// Handle getBillingAndPaymentsLink success
sample({
    source: $$api.misc.getBillingAndPaymentsLinkFx.doneData,
    fn: (data) => data.redirect,
    target: createEffect((redirect: string) => window.open(redirect, '_self')),
});
